
import Grid from '@mui/material/Grid';
import { Navigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import React, { useEffect, useState } from 'react';

import { LOGIN } from '../../helpers/routes';
import { KEY, Kids } from '../../helpers/people';
import ItemList from '../../components/List/ItemList';
import Loading from '../../components/Shared/Loading';
import Typography from '@mui/material/Typography';
import { useFirebase } from '../../contexts/Firebase';
import { useAuth } from '../../contexts/Authentication';
import { onValue } from '../../helpers/Firebase/base';

const Person = () => {
  const firebase = useFirebase();
  const { authenticating, user, name: userName } = useAuth();

  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');

  useEffect(() => {
    if (user && Kids.includes(userName)) {
      setLoading(false);
    } else if (user && !Kids.includes(userName)) {
      const matchRef = firebase.match(userName);
      onValue(matchRef, (data) => {
        if (data.val()) {
          const decrypted = CryptoJS.AES.decrypt(data.val(), KEY);
          setName(decrypted.toString(CryptoJS.enc.Utf8));
        }
        setLoading(false);
      }, { onlyOnce: true });
    }
  }, [firebase, user, userName]);

  if (authenticating || loading) {
    return <Loading />
  }

  if (!authenticating && user && Kids.includes(userName)) {
    return (
      <Grid container item xs={12}>
        <Typography variant={'h5'}>
          Kids don't have a matched person.
        </Typography>
      </Grid>
    );
  }

  if (!authenticating && !user) {
    return <Navigate to={LOGIN} />;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant={'h5'}>
          My Person: {name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ItemList name={name} />
      </Grid>
    </Grid>
  );
};

export default Person;